import {
  Autocomplete,
  createFilterOptions,
  type AutocompleteProps,
} from "@mui/material";
import type { FC } from "react";
import { ArrowIcon } from "../../icons/ArrowIcon";
import styles from "./styles.module.css";

export const AppAutocomplete: FC<
  AutocompleteProps<any, boolean, boolean, boolean>
> = ({ ...props }) => {
  return (
    <Autocomplete
      filterOptions={createFilterOptions({ limit: 500 })}
      className={styles.autocomplete}
      popupIcon={<ArrowIcon />}
      classes={{
        input: styles.input,
        root: styles.autocomplete,
        option: styles.option,
        popper: styles.popper,
        listbox: styles.listbox,
        inputRoot: styles.inputRoot,
        inputFocused: styles.focused,
      }}
      sx={{
        "& .MuiOutlinedInput-notchedOutline": {
          border: 0,
          borderStyle: "none",
        },
      }}
      {...props}
    />
  );
};
